<template>
    <div>
        <el-button type="primary" size="small" @click="() => (visible = true)">查看节假日</el-button>
        <el-checkbox-group
            v-model="checks"
            @change="(data) => $emit('checks', data)"
        >
            <el-checkbox label="工作日">包含工作日</el-checkbox>
            <el-checkbox label="非工作日">包含非工作日</el-checkbox>     
        </el-checkbox-group>
        <el-row>
            <el-col :span="8" class="time_lable">工作时间</el-col>
            <el-col :span="5" class="time_lable">
                <el-switch v-model="hasWorkTime" @change="(data) => $emit('hasWorkTime', data)" />
            </el-col>
            
        </el-row>
        <el-row>
            <el-col :span="8" class="time_lable">工作时段</el-col>
            <el-col :span="16">
                <el-time-picker
                    is-range
                    v-model="workingDate"
                    range-separator="-"
                    style="width: 100%"
                    start-placeholder="开始时间"
                    :default-value="[
                        new Date(0, 0, 0, 8, 0, 0),
                        new Date(0, 0, 0, 17, 0, 0),
                    ]"
                    @change="(data) => $emit('workingDate', data)"
                    value-format="HH:mm"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                >
                </el-time-picker>
            </el-col>
        </el-row>
        <el-dialog
            title="节假日查看"
            width="800px"
            :visible="visible"
            destroyOnClose
            :before-close="handleCancel"
            @cancel="handleCancel"
        >
            <el-calendar v-model="calendarDate">
                <template slot="dateCell" slot-scope="{ date, data }">
                    <div class="holiday-cell">
                        <div>{{ data.day.split("-").slice(1).join("-") }}</div>
                        <div>{{ getDateDetail(data.day).name }}</div>
                    </div>
        
                </template>
            </el-calendar>
            <template slot="footer">
                <el-button @click="handleCancel">关闭</el-button>
            </template>
    
        </el-dialog>
    </div>
</template>
<script>
import moment from "moment"
  
export default {
    name: "DateDaysDialog",
    props: {
        checks: {
            default: () => [],
            type: Array,
        },
        hasWorkTime: {
            default: () => false,
            type: Boolean,
        },
        workingDate: {
            default: () => ['08:00', '17:00'],
            type: Array,
        },
    },
    data() {
        return {
            checksCopy: this.checks,
            visible: false,
            calendarDate: new Date(),
            currentDate: [], // 已选中的日期
            holidayDate: [], // 全年已选中的日期
        }
    },
    watch: {
        visible(val) {
            if (val) {
                //初始化日历
                const year = new Date().getFullYear();
                this.initCalendar(year);
            }
        },
        calendarDate(val, oldVal) {
            if (val && moment(val).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
                console.log("点击了‘今天’按钮");
            } else if (
                val &&
                moment(val).toDate() < moment(oldVal).startOf("month").toDate()
            ) {
                console.log("点击了‘上个月’按钮");
                this.addColor();
            } else if (
                val &&
                moment(val).toDate() > moment(oldVal).endOf("month").toDate()
            ) {
                console.log("点击了‘下个月’按钮");
                this.addColor()
            }
        },
    },
    methods: {
        momentTime: moment,
        //初始化日历
        async initCalendar(year) {
            const { api } = this.$attrs.option
            if(api.getHolidayInfo) {
                const res = await api.getHolidayInfo({year});
                this.holidayDate = res.data;
                this.addColor()
            }
        },
        addColor() {
            const elements = document.getElementsByClassName("holiday-cell")
            elements.forEach((ele) => {
            ele.style.backgroundColor = "#fff"
            })
            this.$nextTick(() => {
                //给已选中的日期加背景色
                this.holidayDate.forEach((val) => {
                    const span = document.getElementById(val.day);
                    if (span) span.style.backgroundColor = "#97836C";
                        if(val.holiday){
                        if (span) span.style.backgroundColor = "#B5C342";
                    }
                    if(val.weekend){
                        if (span) span.style.backgroundColor = "#C56C9C";
                    }
        
                })
            })
        },
        getDateDetail(date){
        const oneList = this.holidayDate.filter(o => o.day === date)
            if (oneList.length > 0) {
            return oneList[0]
            }
            return {}
        },
        //点击选中或取消选中
        handleCancel() {
            this.visible = false;
        }
    }
}
</script>
<style lang="scss" scoped>
    .time_lable {
        line-height: 32px;
    }
    
    ::v-deep .el-calendar-table thead th {
        text-align: center;
    }
    
    .holiday-cell {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
</style>
  